<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">引文檢查器</h1>
                        <h2>Trinka 引文檢查器自動找出可能削弱研究的引用，並協助引用更具公信力的來源</h2>
                        <p>Trinka 引文檢查器會自動辨識削弱研究主張與論點的引用，並協助您引用更具可信度與說服力的文獻，強化整體論證品質。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/features/citation-checker/Reference-Quality-Check.webp" width="1200" height="983" alt="Citation Checker" class="img-fluid md50">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2" #viewVideo>
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/yt-thumbnail/citation-video.webp" width="1280" height="720" alt="citation video" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「引文檢查器」功能！</p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p>還有其他問題嗎？歡迎瀏覽我們的常<a (click)="scroll(target)" class="text-link">見問答</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>引文檢查器主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 引文檢查器提供全面的引用品質風險分析，幫助你優化引用清單，強化研究論證。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="media gap-15">
                        <div class="media-left">
                            <img src="../../../assets/images/Retracted-References.png" loading="lazy" decoding="async" alt="Retracted">
                        </div>
                        <div class="media-body">
                            <h3>撤回引用</h3>
                            <p>辨識已被撤回的研究，避免遭受審稿人因引用撤回文獻而提出批評。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <div class="media gap-15">
                        <div class="media-left">
                            <img src="../../../assets/images/Non-standard-References.png" loading="lazy" decoding="async" alt="non standard">
                        </div>
                        <div class="media-body">
                            <h3>未驗證引用</h3>
                            <p>排除未收錄於引用資料庫中的文獻，提升引用的可信度。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <div class="media gap-15">
                        <div class="media-left">
                            <img src="../../../assets/images/Old-References.png" loading="lazy" decoding="async" alt="old reference">
                        </div>
                        <div class="media-body">
                            <h3>過舊引用</h3>
                            <p>輕鬆找出發表年代較久遠的論文，確保引用的相關性與有效性。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <div class="media gap-15">
                        <div class="media-left">
                            <img src="../../../assets/images/Overuse.png" loading="lazy" decoding="async" alt="overuse">
                        </div>
                        <div class="media-body">
                            <h3>期刊過度引用</h3>
                            <p>發現對特定期刊的無意偏重，透過多元化引用來源避免審稿人質疑。</p>
                        </div>
                    </div>
                   
                    
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd bg-light-purple list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>為什麼選擇 Trinka 引文檢查器？</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="media gap-15">
                        <div class="media-left">
                            <img src="/assets/images/languageScore_icon.svg" width="40" height="40" alt="Free Score Overview" />
                        </div>
                        <div class="media-body">
                            <h3>免費分數概覽</h3>
                            <p>免費產生引用分析分數，僅在需要報告時付費，讓你靈活掌控使用。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <div class="media gap-15">
                        <div class="media-left">
                            <img src="/assets/images/Up-to-date-Repository.png" width="40" height="40" alt="Free Score Overview" />
                        </div>
                        <div class="media-body">
                            <h3>Crossref 驗證</h3>
                            <p>所有引用皆透過 Crossref 廣泛的出版資料庫進行驗證，這是全球出版社與組織信賴的權威來源。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-security-section></app-security-section>

<section class="cloud_key_features section-pd pt-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>查看範例報告！</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>透過 Trinka 引文檢查器的範例報告，了解如何提升你的論文引用品質與說服力！</p>
                </div>
            </div>
            <div class="col-12">
                <div class="viewSampleReportImg">
                    <div class="btn-group">
                        <a href="citation-checker/sample-report" class="filled-btn" target="_blank">
                            查看完整報告
                            <svg fill="#ffffff" width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14 3.414L9.414 8 14 12.586v-2.583h2V16h-6v-1.996h2.59L8 9.414l-4.59 4.59H6V16H0v-5.997h2v2.583L6.586 8 2 3.414v2.588H0V0h16v6.002h-2V3.414zm-1.415-1.413H10V0H6v2H3.415L8 6.586 12.585 2z" fill-rule="evenodd"></path> </g></svg>
                        </a>
                    </div>
                    <img src="/assets/images/features/citation-checker/citation-report.webp" width="766" height="770" alt="citation">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h3 class="text-white">立即獲取您的免費引文分析分數</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">開始使用</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="section-pd pb-0">
    <app-credits-info
        [title]="'引文檢查器使用點數'"
        [description]="'引文檢查為免費評分，僅需付費即可取得完整報告。每 1 個點數可生成最多 30 筆引文的報告，可使用免費點數或視需求購買額外點數。'"
        [subText]="'高級用戶每月將獲得 10 個免費點數，基本用戶每月獲得 4 個免費點數。瞭解更多資訊，<a href=\'/features/credits\' class=\'text-link\'>請點擊此處</a>。'"
    ></app-credits-info>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka 引文檢查器怎麼運作？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>只需 3 個簡單步驟，即可提升您的引文品質！ </h4>
                                        <ol>
                                            <li>免費註冊 <a href="https://cloud.trinka.ai/signup_rg=TW" target="_blank">Trinka 帳號。</a> </li>
                                            <li>在左側導覽列點選「引文檢查器」。 </li>
                                            <li>上傳文件（可從 Google Drive、Dropbox 或電腦上傳），也可以使用您已經上傳到 Trinka 的文件。幾分鐘內即可取得分析報告！</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        哪裡可以使用 Trinka 引文檢查器？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 引文檢查器目前僅提供於 Trinka Cloud ，所有用戶皆可使用。我們也將很快推出 Word 增益集版本，敬請期待！</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        可以檢查引用付費期刊的文獻嗎？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，即使您的引用出自付費期刊，我們也能協助您進行引文檢查。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以與共同作者分享引文報告嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                        <p>目前尚未開放分享功能，但這項功能已在開發中，未來將可支援與共同作者共享報告！</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-trinka-in-other-apps></app-trinka-in-other-apps>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/XBuFdCM3xtk"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>